import React from 'react';
import VerificationStatusView from './VerificationStatusView';
const strings = {
    verified: 'Verified',
    verify: 'Verify your email',
};
const EmailVerificationStatusView = ({ verified, ...props }) => (<VerificationStatusView state={verified ? 'verified' : 'unverified'} label={verified ? strings.verified : strings.verify} {...props}/>);
export default EmailVerificationStatusView;
